import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { DeploymentService } from '../../../../core/services/deployment.service';

@Component({
  selector: 'app-change-deployment-name',
  templateUrl: './change-deployment-name.component.html',
  styleUrls: ['./change-deployment-name.component.scss']
})
export class ChangeDeploymentNameComponent implements OnInit {

  constructor(
    private deploymentService: DeploymentService,
    public dialogRef: MatDialogRef<ChangeDeploymentNameComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { depName: string },
    private _spinner: NgxSpinnerService,
    private snackBar: MatSnackBar
  ) { }

  deploymentNameChangeForm: UntypedFormGroup = new UntypedFormGroup({
    newDepName: new UntypedFormControl("", [Validators.required, Validators.pattern(/^[a-z][a-z0-9_-]{2,10}$/)])
  });
  depName = this.data.depName;

  ngOnInit(): void {
  }

  onSubmit() {
    this._spinner.show("updateCredential");
    let newDepName = this.deploymentNameChangeForm.value?.newDepName?.toString();
    this.deploymentService.updateDeploymentName(this.depName, newDepName)
      .subscribe({
        next: (data) => {
          this.snackBar.open('Successfully changed deployment name.', 'Ok', {
            duration: 3000
          })
          this.onCancel();
        },
        error: (err) => {
          this.snackBar.open('Cannot change deployment name.', 'Ok', {
            duration: 3000
          })
          this.onCancel();
        }
      })
  }

  onCancel() {
    this.dialogRef.close();
  }
}
